import React, { useEffect, useState } from "react";
import { CommonUtilities } from "../../../commonUtils";
import ISRCMappingBox from "../ISCRCMapping";
import TransactionServices from "../TransactionServices";
import MatchingForm from "./MatchingForm";


export default function Matching(subEntity: any) {
    const [showtab, setShowTab] = useState(1);
    const [showtabArena, setshowtabArena] = useState(1);
    const [loop, setloop] = useState(1);
    let [activeMenu, setActiveMenu] = useState("Matching");
    const [searchFor, setSearchFor] = useState("");
    var dataLink = "pageSize=10&pageNumber=1";
    const [currentList, initCurrentList] = useState<any[]>([]);
    const [totalRows, setTotalRows] = useState(1);
    const onChangeMenu = (e: any) => {
        console.log(e)
        setActiveMenu(e)
    }


    let [matchingTerritoriesStatus, setMatchingTerritoriesStatus] = useState(false);
    const matchingTerritories = () => {
        setMatchingTerritoriesStatus(true)
    }
    let [openMatchingTerritories, setOpenMatchingTerritories] = useState(false);
    const MatchingTerritoriesClose = () => {
        matchingTerritoriesStatus = false
        setMatchingTerritoriesStatus(false)
    }


    let [isrcMappingStatus, setISRCMappingStatus] = useState(false);
    const isrcMapping = () => {
        setISRCMappingStatus(true)
    }

    let [openISRCMapping, setOpenISRCMapping] = useState(false);
        const ISRCMappingClose = () => {
            isrcMappingStatus = false
            setISRCMappingStatus(false)
        }








    let [matchingSearch, setMatchingSearch] = useState<any[]>([]);
    const SearchListing = () => {
        var payload = { pageNumber: 1, pageSize: 10, catalogueIsRc: '', territoryCode: '', invoiceRef: '', accountCode: '', uniqueReference: '', zone: '', zoneForTerritories: '', analysisCode: '', formatCode: '', albumCode: '', itemCodeSold: '', trackCode: '', subProvider: '', songTitle: '', writerName: '', publisherName: '', unTransferred: 0 }
        TransactionServices.matchingSearch(payload).then((res: any) => {
            console.log(res)
            matchingSearch = res
            setMatchingSearch(res)
            console.log("search button for matching")
        })
    }

    let [postApprovedtrue, setpostApprovedtrue] = useState(false);
    let [postApprovedfalse, setpostApprovedfalse] = useState(false);
    let [updateCommitResultsTrue, setupdateCommitResultsTrue] = useState(false);
    let [updateCommitResultsFalse, setupdateCommitResultsFalse] = useState(false);

    const currentPage = (e: number) => {
        setShowTab(e);

        if (searchFor.length > 0) {
            dataLink = dataLink + "&searchFor=" + searchFor
        }
        if (e === 1) {
            TransactionServices.PublishingSong(dataLink).then((res) => {
                initCurrentList(res)
                if (res.length < 1) { setTotalRows(0) }
                else { setTotalRows(res[0].totalRows); }
            })
        }
        if (e === 2) {
            TransactionServices.PublishingWriter(dataLink).then((res) => {
                initCurrentList(res)
                if (res.length < 1) { setTotalRows(0) }
                else { setTotalRows(res[0].totalRows); }
            })
        }
        if (e === 3) {
            TransactionServices.Digital(dataLink).then((res) => {
                initCurrentList(res)
                if (res.length < 1) { setTotalRows(0) }
                else { setTotalRows(res[0].totalRows); }
            })
        }
        if (e === 4) {
            TransactionServices.Physical(dataLink).then((res) => {
                initCurrentList(res)
                if (res.length < 1) { setTotalRows(0) }
                else { setTotalRows(res[0].totalRows); }
            })
        }
        if (e === 5) {
            TransactionServices.Costs(dataLink).then((res) => {
                initCurrentList(res)
                if (res.length < 1) { setTotalRows(0) }
                else { setTotalRows(res[0].totalRows); }
            })
        }
        if (e === 6) {
            TransactionServices.Advances(dataLink).then((res) => {
                initCurrentList(res)
                if (res.length < 1) { setTotalRows(0) }
                else { setTotalRows(res[0].totalRows); }
            })
        }
        if (e === 7) {
            TransactionServices.Licensing(dataLink).then((res) => {
                initCurrentList(res)
                if (res.length < 1) { setTotalRows(0) }
                else { setTotalRows(res[0].totalRows); }
            })
        }
        if (e === 8) {
            TransactionServices.Adjustments(dataLink).then((res) => {
                initCurrentList(res)
                if (res.length < 1) { setTotalRows(0) }
                else { setTotalRows(res[0].totalRows); }
            })
        }
    }

    const songArena = (e: number) => {
        setshowtabArena(e);

        if (searchFor.length > 0) {
            dataLink = dataLink + "&searchFor=" + searchFor
        }
        if (e === 1) {
            TransactionServices.Raw(dataLink).then((res) => {
                initCurrentList(res)
                if (res.length < 1) { setTotalRows(0) }
                else { setTotalRows(res[0].totalRows); }
            })
        }
        if (e === 2) {
            TransactionServices.Audit(dataLink).then((res) => {
                initCurrentList(res)
                if (res.length < 1) { setTotalRows(0) }
                else { setTotalRows(res[0].totalRows); }
            })
        }
        if (e === 3) {
            TransactionServices.Publishing(dataLink).then((res) => {
                initCurrentList(res)
                if (res.length < 1) { setTotalRows(0) }
                else { setTotalRows(res[0].totalRows); }
            })
        }

    }


    const tab_Name = (tabNumber: any) => {
        var tableName = "Publishing - Song";
        if (tabNumber == 1) {    tableName = "Publishing - Song"    }
        if (tabNumber == 2) {    tableName = "Publishing - Writer"    }
        if (tabNumber == 3) {    tableName = "Digital"    }
        if (tabNumber == 4) {    tableName = "Physical"    }
        if (tabNumber == 5) {    tableName = "Cost"    }
        if (tabNumber == 6) {    tableName = "Advances"    }
        if (tabNumber == 7) {    tableName = "Licensing"    } 
        if (tabNumber == 8) {    tableName = "Adjustments"    } 
        
        return tableName;
    }

    return (
        <div className="ws-12">

            <div className="ws-12">
                <div className="ws-2 ps">
                    <div className="controls" title="Choose a period">
                        <select className="ws-12" id="period" title="Choose a period">
                            <option value="20140331" className="btn">
                                Jan 1, 2014 - Mar 31, 2014
                            </option>
                        </select>
                    </div>
                </div>

                <div className="ws-10 mbl">
                    <a id="1" className={showtab === 1 ? "btn-success active" : "btn-success"} onClick={() => currentPage(1)}>Publishing - Song</a>
                    <a id="2" className={showtab === 2 ? "btn-success active" : "btn-success"} onClick={() => currentPage(2)}>Publishing - Writer</a>
                    <a id="3" className={showtab === 3 ? "btn-success active" : "btn-success"} onClick={() => currentPage(3)}>Digital</a>
                    <a id="4" className={showtab === 4 ? "btn-success active" : "btn-success"} onClick={() => currentPage(4)}>Physical</a>
                    <a id="5" className={showtab === 5 ? "btn-success active" : "btn-success"} onClick={() => currentPage(5)}>Cost</a>
                    <a id="6" className={showtab === 6 ? "btn-success active" : "btn-success"} onClick={() => currentPage(6)}>Advances</a>
                    <a id="7" className={showtab === 7 ? "btn-success active" : "btn-success"} onClick={() => currentPage(7)}>Licensing</a>
                    <a id="8" className={showtab === 8 ? "btn-success active" : "btn-success"} onClick={() => currentPage(8)}>Adjustments</a>
                </div>

                <div className="ws-12">

                    <div className="ws-2 p0 pls prs">
                        <div className="box">
                            <div className="box-header well">
                                <h2 ><i className="icon-search1"></i> Publishing - Song Arena</h2>
                            </div>

                            <div className="box-content">

                                <div className="control-group" data-ng-show="showUniqueReference">
                                    <label className="control-label ">Unique reference</label>
                                    <div className="controls">
                                        <input type="text" placeholder="Unique reference" className="mt mb ws-12 " data-ng-model="search.uniqueReference" id="uniqueReference" />
                                    </div>
                                </div>

                                <div className="control-group" data-ng-show="showInvoiceRef">
                                    <label className="control-label ">Invoice Ref</label>
                                    <div className="controls">
                                        <input type="text" placeholder="Invoice Ref" className="mt mb ws-12 " data-ng-model="search.invoiceRef" id="invoiceRef" />
                                    </div>
                                </div>

                                <div className="control-group" data-ng-show="showAccountCode">
                                    <label className="control-label ">Account</label>
                                    <div className="controls">
                                        <input type="text" placeholder="Account" className="mt mb ws-12 " data-ng-model="search.accountCode" id="account" />
                                    </div>
                                </div>

                                <div className="control-group" data-ng-show="showItemCodeSold">
                                    <label className="control-label ">Item Code Sold</label>
                                    <div className="controls">
                                        <input type="text" placeholder="Item Code Sold" className="mt mb ws-12 " data-ng-model="search.itemCodeSold" id="itemCodeSold" />
                                    </div>
                                </div>

                                <div className="control-group" data-ng-show="showTerritoryCode">
                                    <label className="control-label ">Territory</label>
                                    <div className="controls">
                                        <input data-ng-model="search.territoryCode" type="text" className="mt mb ws-12 " placeholder="Territory" id="territory" name="territory" />
                                    </div>
                                </div>

                                <div className="control-group" data-ng-show="showFormatCode">
                                    <label className="control-label ">Formats/Source Codes</label>
                                    <div className="controls">
                                        <input type="text" placeholder="Formats/Source Codes" className="mt mb ws-12 " data-ng-model="search.formatCode" id="formatCode" />
                                    </div>
                                </div>

                                <div className="control-group" data-ng-show="showAnalysisCode">
                                    <label className="control-label ">Analysis Code</label>
                                    <div className="controls">
                                        <input type="text" placeholder="Analysis Code" className="mt mb ws-12 " data-ng-model="search.analysisCode" id="analysisCode" />
                                    </div>
                                </div>

                                <div className="control-group ng-hide" data-ng-show="showAlbumCode">
                                    <label className="control-label ">Album Code</label>
                                    <div className="controls">
                                        <input type="text" placeholder="Album Code" className="mt mb ws-12 " data-ng-model="search.albumCode" id="albumCode" />
                                    </div>
                                </div>

                                <div className="control-group ng-hide" data-ng-show="showSubProvider">
                                    <label className="control-label ">Sub Provider</label>
                                    <div className="controls">
                                        <input type="text" placeholder="Sub Provider" className="mt mb ws-12 " data-ng-model="search.subProvider" id="subProvider" />
                                    </div>
                                </div>

                                <div className="control-group ng-hide" data-ng-show="showTrackCode">
                                    <label className="control-label " >Track Code</label>
                                    <div className="controls">
                                        <input type="text" placeholder="Track Code" className="mt mb ws-12 " data-ng-model="search.trackCode" id="trackCode" />
                                    </div>
                                </div>

                                <div className="control-group ng-hide" data-ng-show="showCatalogueIsRc">
                                    <label className="control-label ">Catalog/ISRC</label>
                                    <div className="controls">
                                        <input data-ng-model="search.catalogueIsRc" type="text" placeholder="Catalog/ISRC" id="CatLogNumber" className="mt mb ws-12 " name="CatLogNumber" />
                                    </div>
                                </div>

                                <div className="control-group ng-hide" data-ng-show="showZoneForTerritories">
                                    <label className="control-label ">Zone for territories</label>
                                    <div className="controls">

                                        <select className="form-control mb mt ws-12 " id="zoneForTerritories" ng-model="search.zoneForTerritories">
                                            <option value="" selected >Please select a zone for territories
                                            </option>

                                        </select>
                                    </div>
                                </div>


                                <div className="control-group ng-hide" data-ng-show="showZone">
                                    <label className="control-label ">Zone</label>
                                    <div className="controls">

                                        <select className="form-control mt mb ws-12 " ng-change="loadTerritoryForZone()" id="Zone" ng-model="search.zone">
                                            <option value="" selected >Please select a zone</option>
                                            <option value="US" ng-repeat="option in zones" >US</option><option value="CA" ng-repeat="option in zones" >CA</option><option value="UK" ng-repeat="option in zones" >UK</option><option value="MX" ng-repeat="option in zones" >MX</option>                       </select>
                                    </div>
                                </div>

                                <div className="control-group ng-hide" data-ng-show="showTransRef">
                                    <label className="control-label " >TransRef</label>
                                    <div className="controls">
                                        <input data-ng-model="search.transRef" type="text" placeholder="Trans Ref" className="mt mb ws-12 " id="TransRef" name="TransRef" />
                                    </div>
                                </div>

                                <div className="control-group" data-ng-show="showSongTitle">
                                    <label className="control-label ">Song Title</label>
                                    <div className="controls">
                                        <input data-ng-model="search.songTitle" type="text" placeholder="Song Title" id="SongTitle" className="mt mb ws-12 " name="SongTitle" />
                                    </div>
                                </div>

                                <div className="control-group" data-ng-show="showWriterName">
                                    <label className="control-label ">Writer Name</label>
                                    <div className="controls">
                                        <input data-ng-model="search.writerName" type="text" placeholder="Writer Name" id="WriterName" className="mt mb ws-12 " name="WriterName" />
                                    </div>
                                </div>

                                <div className="control-group" data-ng-show="showPublisherName">
                                    <label className="control-label ">Publisher Name</label>
                                    <div className="controls">
                                        <input data-ng-model="search.publisherName" type="text" placeholder="Publisher Name" id="PublisherName" className="mt mb ws-12 " name="PublisherName" />
                                    </div>
                                </div>

                                <div className="control-group" data-ng-show="showSongCode">
                                    <label className="control-label ">Song Code</label>
                                    <div className="controls">
                                        <input data-ng-model="search.songCode" type="text" placeholder="Song Code" className="mt mb ws-12 " id="SongCode" name="SongCode" />
                                    </div>
                                </div>

                                <div className="control-group ws-12 mt ng-hide" data-ng-show="showUnTransferred">
                                    <label className="ws-8">Non-Transferred</label>
                                    <input type="checkbox" data-ng-model="search.unTransferred" data-ng-true-value="1" className="mb ws-2 " data-ng-false-value="0" />
                                </div>
                            </div>

                            <div className="box-footer ws-12 pull-right">
                                <div className="ws-6">
                                    <a className="btn icon-btn edit" onClick={SearchListing} title="Search">Search</a>
                                </div>
                                <div className="ws-6">
                                    <a className="btn btn-pink mt " data-ng-click="searchClear()">Reset</a>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="ws-10">
                        <div className="box">
                            {
                                postApprovedtrue && <div className="alert alert-ing">Operation queued for processing</div>
                            }
                            {
                                postApprovedfalse && <div className="alert alert-info">Re-run this operation after a few mins as similar job already in progress</div>
                            }
                            <div className="box-header well">
                                <h2 className="ws-3 "> 
                                    <span >{tab_Name(showtab)} - 0 record(s) found</span>
                                </h2>

                                <div className="ws-9">

                                    <a className="icon-btn warning  pull-right " ng-click="invoicePostApproved(period, (isActiveType('Mechanical') ? 1 : 0))" ng-disabled="invoicePostApprovedBlock">
                                        Post Approved
                                    </a>

                                    <button className="btn icon-btn edit pull-right " data-ng-click="updateCommitSystem()" ng-disabled="invoicePostApprovedBlock">
                                        Update and Commit System
                                    </button>

                                    <a title="Print Checkings Report" className="icon-btn primary pull-right " target="_blank" href="../../CrystalReport/viewReport.aspx?report=/reports/501.rpt">
                                        Print Report
                                    </a>

                                    <button className="icon-btn primary pull-right " onClick={() => isrcMapping()}>
                                        ISRC Mapping
                                    </button>

                                    <button className="icon-btn primary pull-right" onClick={() => matchingTerritories()}>
                                        Matching
                                    </button>

                                </div>
                            </div>
                            <div className="box-content">
                                {
                                    updateCommitResultsTrue && <div className="alert alert-info">Operation queued for processing</div>
                                }
                                {
                                    updateCommitResultsFalse && <div className="alert alert-info">Re-run this operation after a few mins as similar job already in progress</div>
                                }
                                <div className="ws-12 mt mbl">
                                    <button className="hide icon-btn primary  btn-grey ng-hide" ng-className="isActiveType('Raw') ? 'icon-btn primary' : 'btn-grey'" data-ng-click="openType('Raw')" ng-hide="(currentTab.type == 'publishingSong' || currentTab.type == 'publishingWriter')">Raw</button>
                                    <button ng-className="isActiveType('Act') ? 'nav-horizontal active' : 'nav-horizontal'" data-ng-click="openType('Act')" ng-hide="(currentTab.type == 'publishingSong' || currentTab.type == 'publishingWriter')" className="hide  nav-horizontal ng-hide">Audit</button>
                                    <button ng-className="isActiveType('RawPub') ? 'nav-horizontal active' : 'nav-horizontal'" data-ng-click="openType('RawPub')" ng-show="(currentTab.type == 'publishingSong' || currentTab.type == 'publishingWriter')" className="hide  nav-horizontal">Raw</button>
                                    <button ng-className="isActiveType('ActPub') ? 'nav-horizontal active' : 'nav-horizontal'" data-ng-click="openType('ActPub')" ng-show="(currentTab.type == 'publishingSong' || currentTab.type == 'publishingWriter')" className="hide  nav-horizontal">Audit</button>
                                    <button ng-className="isActiveType('Royalty') ? 'nav-horizontal active' : 'nav-horizontal'" data-ng-click="openType('Royalty')" ng-show="(currentTab.type == 'publishingSong' || currentTab.type == 'publishingWriter')" className="hide  nav-horizontal">Publishing</button>
                                    <button ng-className="isActiveType('Royalty') ? 'nav-horizontal active' : 'nav-horizontal'" data-ng-click="openType('Royalty')" ng-hide="(currentTab.type == 'publishingSong' || currentTab.type == 'publishingWriter')" className="hide  nav-horizontal ng-hide">Royalty</button>
                                    <button ng-className="isActiveType('Mechanical') ? 'nav-horizontal active' : 'nav-horizontal'" data-ng-click="openType('Mechanical')" ng-hide="(currentTab.type == 'publishingSong' || currentTab.type == 'publishingWriter')" className="hide  nav-horizontal ng-hide">Mechanical</button>

                                    <a id="1" className={showtabArena === 1 ? "icon-btn edit active" : "icon-btn edit"} onClick={() => songArena(1)}>Raw</a>
                                    <a id="2" className={showtabArena === 2 ? "icon-btn edit active" : "icon-btn edit"} onClick={() => songArena(2)}>Audit</a>
                                    <a id="3" className={showtabArena === 3 ? "icon-btn edit active" : "icon-btn edit"} onClick={() => songArena(3)}>Publishing</a>
                                    <a id="4" className={showtabArena === 4 ? "icon-btn edit active" : "icon-btn edit"} onClick={() => songArena(4)}>Royalty</a>
                                    <a id="5" className={showtabArena === 5 ? "icon-btn edit active" : "icon-btn edit"} onClick={() => songArena(5)}>Mechanical</a>


                                </div>
                                <div className="alert alert-info mt " data-ng-show="!isActiveType('Raw') &amp;&amp; !isActiveType('Act') &amp;&amp; !isActiveType('Royalty') &amp;&amp; !isActiveType('Mechanical') &amp;&amp; !isActiveType('RawPub') &amp;&amp; !isActiveType('ActPub')">
                                    Select a type of fact sales to display
                                </div>
                                <div data-ng-show="isActiveType('Raw')" className="mt ng-hide">
                                    <div className="alert alert-info " data-ng-hide="factSales['Raw']['totalItems'] &gt; 0">No data to display
                                    </div>
                                    <div className="table-responsive_big mt ng-hide" data-ng-show="factSales['Raw']['totalItems'] &gt; 0">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th >Hold flag</th>
                                                    <th >Invoice Ref</th>
                                                    <th >Account Code</th>
                                                    <th >Matched Item</th>
                                                    <th >Territory Code</th>
                                                    <th >Formats/Source Codes</th>
                                                    <th >Analysis Code</th>
                                                    <th >Units Sold</th>
                                                    <th >Monetary Value</th>
                                                    <th >Invoice Date</th>
                                                    <th >Album Title</th>
                                                    <th >Track Title</th>
                                                    <th >Album Artist</th>
                                                    <th >Track Artist</th>
                                                    <th >Operations</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {matchingSearch?.map(values => {
                                                    return (
                                                        <tr>
                                                            <td>{values.holdFlag}</td>
                                                            <td>{values.invoiceRef}</td>
                                                            <td>{values.accountCode}</td>
                                                            <td>{values.itemCodeSold}</td>
                                                            <td>{values.mtchTerritoryCode}</td>
                                                            <td>{values.mtchFormatCode}</td>
                                                            <td>{values.mtchAnalysisCode}</td>
                                                            <td>{values.analysisCode}</td>
                                                            <td>{values.unitsSold}</td>
                                                            <td>{values.monetaryValue}</td>
                                                            <td>{values.invoiceDate}</td>
                                                            <td>{values.albumTitle}</td>
                                                            <td>{values.trackTitle}</td>
                                                            <td>{values.albumArtist}</td>
                                                            <td>{values.trackArtist}</td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                        <div className="row-fluid">
                                            <div className="ws-3 ">
                                                <strong >Sum monetary value</strong> :
                                            </div>
                                            <div className="span3 ">
                                                <strong >Total units sold</strong> :
                                            </div>
                                        </div>
                                    </div>

                                    <div className="clearfix mt ng-hide" data-ng-show="factSales['Raw']['totalItems'] &gt; 0">

                                        <div className="hover-box">
                                            <a className="icon-btn edit"><i className="icon-download1"></i>
                                                <div className="label label-danger pull-right  m0 p0 ml ng-hide" data-ng-show="false">might take a while</div>
                                            </a> <div className="hover-block">
                                                <button className="btn icon-btn edit btn-xs pull-left mr" data-ng-click="exportPopupOptions(period)">Export for a
                                                    specific period</button>
                                                <button className="btn icon-btn edit btn-xs pull-left" data-ng-click="exportPopupOptions('')">Export for all
                                                    periods</button>
                                            </div>
                                        </div>
                                        <div className="clearfix pull-right">

                                        </div>
                                    </div>
                                </div>
                                <div data-ng-show="isActiveType('Act')" className="hide">
                                    <div className="alert alert-info " data-ng-hide="factSales['Act']['totalItems'] &gt; 0">No data to
                                        display
                                    </div>
                                    <div className="table-responsive_big mt ng-hide" data-ng-show="factSales['Act']['totalItems'] &gt; 0">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th >Hold flag</th>
                                                    <th >Invoice Ref</th>
                                                    <th >Account Code</th>
                                                    <th >Matched Item</th>
                                                    <th >Territory Code</th>
                                                    <th >Formats/Source Codes</th>
                                                    <th >Analysis Code</th>
                                                    <th >Units Sold</th>
                                                    <th >Monetary Value</th>
                                                    <th >Invoice Date</th>
                                                    <th >Album Title</th>
                                                    <th >Track Title</th>
                                                    <th >Album Artist</th>
                                                    <th >Track Artist</th>
                                                    <th >Operations</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                        <div className="row-fluid">
                                            <div className="ws-3 ">
                                                <strong>Sum monetary value</strong> :
                                            </div>
                                            <div className="ws-3 ">
                                                <strong>Total units sold</strong> :
                                            </div>
                                        </div>

                                    </div>

                                    <div className="clearfix mt ng-hide" data-ng-show="factSales['Act']['totalItems'] &gt; 0">

                                        <div className="hover-box pull-left">
                                            <a className="icon-btn edit"><i className="icon-download1"></i>
                                                <span className="label label-danger pull-right  m0 p0 ml ng-hide" data-ng-show="false">might take a while</span>
                                            </a><div className="hover-block">
                                                <a className="btn btn-large btn-app icon-btn edit btn-xs pull-left mr" href="javascript:void(0)" data-ng-click="exportPopupOptions(period)">Export for a
                                                    specific period</a>
                                                <a className="btn btn-large btn-app icon-btn edit btn-xs pull-left" href="javascript:void(0)" data-ng-click="exportPopupOptions('')">Export for all
                                                    periods</a>
                                            </div>
                                        </div>
                                        <div className="clearfix pull-right">
                                            {/* <ul className="pull-left pagination ng-isolate-scope ng-valid ng-hide" total-items="factSales['Act']['totalItems']" rotate="false" ng-model="factSales['Act']['currentPage']" max-size="3" boundary-links="true" items-per-page="factSales['Act']['itemsPerPage']" ng-change="factSales['Act']['pageChanged'](factSales['Act']['currentPage'])" data-ng-show="factSales['Act']['totalItems'] &gt; factSales['Act']['itemsPerPage']">
  <li ng-if="::boundaryLinks" ng-className="{disabled: noPrevious()||ngDisabled}" className=" disabled"><a href="" ng-click="selectPage(1, $event)" >First</a></li>
  <li ng-if="::directionLinks" ng-className="{disabled: noPrevious()||ngDisabled}" className=" disabled"><a href="" ng-click="selectPage(page - 1, $event)" >Previous</a></li>
  <li ng-repeat="page in pages track by $index" ng-className="{active: page.active,disabled: ngDisabled&amp;&amp;!page.active}" className=" active"><a href="" ng-click="selectPage(page.number, $event)" >1</a></li>
  <li ng-if="::directionLinks" ng-className="{disabled: noNext()||ngDisabled}" className=" disabled"><a href="" ng-click="selectPage(page + 1, $event)" >Next</a></li>
  <li ng-if="::boundaryLinks" ng-className="{disabled: noNext()||ngDisabled}" className=" disabled"><a href="" ng-click="selectPage(totalPages, $event)" >Last</a></li>
</ul> */}
                                            <div className="page-size-control">
                                                <select data-ng-options="item as item for item in pageSizes" data-ng-model="factSales['Act']['itemsPerPage']" data-ng-change="loadFactSales()" data-ng-show="factSales['Act']['totalItems'] &gt; factSales['Act']['itemsPerPage']" className=" ng-hide"><option value="0" selected label="10">10</option><option value="1" label="20">20</option><option value="2" label="50">50</option><option value="3" label="100">100</option></select>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="table-responsive_big mt ws-12">
                                    <table className="table ng-hide" data-ng-show="selectedfactSale">
                                        <thead>
                                            <tr>
                                                <th >Unique ID</th>
                                                <th >Album Code1</th>
                                                <th >Album Code2</th>
                                                <th >Track Code1</th>
                                                <th >Track Code2</th>
                                                <th >Dealer Price</th>
                                                <th >Retail Price</th>
                                                <th >Sub Provider</th>
                                                <th >Sub Content</th>
                                                <th >Sub Formats/Source Codes</th>
                                                <th >Reported Item</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td ></td>
                                                <td ></td>
                                                <td ></td>
                                                <td ></td>
                                                <td ></td>
                                                <td className="text-right "></td>
                                                <td className="text-right "></td>
                                                <td ></td>
                                                <td ></td>
                                                <td ></td>
                                                <td ></td>
                                            </tr>
                                        </tbody>
                                    </table>

                                </div>


                                <div data-ng-show="isActiveType('Royalty')" className="hide">

                                    <div className="alert alert-info " data-ng-hide="factSales['Royalty']['totalItems'] &gt; 0">No data to
                                        display
                                    </div>

                                    <div className="table-responsive_big mt ng-hide" data-ng-show="factSales['Royalty']['totalItems'] &gt; 0">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th >ItemCodeSold</th>
                                                    <th >TotalUnits</th>
                                                    <th >TotalAmount</th>
                                                    <th >MtchTerritoryCode</th>
                                                    <th >Formats/Source Codes</th>
                                                    <th >MtchAnalysisCode</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>

                                        <div className="hover-box pull-right mt ng-hide" data-ng-show="factSales['Royalty']['totalItems'] &gt; 0">
                                            <a className="icon-btn edit " data-ng-click="exportRoyalty()"><i className="icon-download1"></i> Export
                                                <span className="label label-danger pull-right  m0 p0 ml ng-hide" data-ng-click="exportRoyalty()" data-ng-show="false">might take a while</span>

                                            </a>
                                            <div className="hover-block" >
                                                <a className="btn btn-large btn-app icon-btn edit btn-xs " href="javascript:void(0)" ng-click="exportRoyaltySummary()">Summary</a>
                                                <a className="btn btn-large btn-app icon-btn edit btn-xs " href="javascript:void(0)" ng-click="exportRoyalty()">All</a>
                                            </div>
                                        </div>


                                    </div>
                                    <div className="clearfix ng-hide" data-ng-show="factSales['Royalty']['totalItems'] &gt; 0">

                             
                                    </div>
                                </div>

                                <div data-ng-show="isActiveType('Mechanical')" className="hide">
                                    <div className="alert alert-info " data-ng-hide="factSales['Mechanical']['totalItems'] &gt; 0">No data to
                                        display
                                    </div>
                                    <div className="table-responsive_big mt ng-hide" data-ng-show="factSales['Mechanical']['totalItems'] &gt; 0">

                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th >ItemCodeSold</th>
                                                    <th >TotalUnits</th>
                                                    <th >TotalAmount</th>
                                                    <th >MtchTerritoryCode</th>
                                                    <th >Formats/Source Codes</th>
                                                    <th >MtchAnalysisCode</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>

                                        <div className="hover-box pull-right mt ng-hide" data-ng-show="factSales['Mechanical']['totalItems'] &gt; 0">
                                            <a className="icon-btn edit " data-ng-click="exportMechanical()"><i className="icon-download1"></i> Export
                                                <span className="label label-danger pull-right  m0 p0 ml ng-hide" data-ng-click="exportMechanical()" data-ng-show="false">might take a while</span>
                                            </a>
                                            <div className="hover-block" >
                                                <a className="btn btn-large btn-app icon-btn edit btn-xs " href="javascript:void(0)" ng-click="exportMechanicalSummary()">Summary</a>
                                                <a className="btn btn-large btn-app icon-btn edit btn-xs " href="javascript:void(0)" ng-click="exportMechanical()">All</a>

                                            </div>
                                        </div>

                                    </div>
                                    <div className="clearfix ng-hide" data-ng-show="factSales['Mechanical']['totalItems'] &gt; 0">

                                  
                                    </div>
                                </div>
                                <div data-ng-show="isActiveType('RawPub')" className="hide">
                                    <div className="alert alert-info " data-ng-hide="factSales['RawPub']['totalItems'] &gt; 0">No data to
                                        display
                                    </div>

                                    <div className="table-responsive_big mt ng-hide" data-ng-show="factSales['RawPub']['totalItems'] &gt; 0">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th >Switch</th>
                                                    <th >Invoice Ref</th>
                                                    <th >Account Code</th>
                                                    <th >Matched Item</th>
                                                    <th >Territory Code</th>
                                                    <th >Formats/Source Codes</th>
                                                    <th >Units Sold</th>
                                                    <th >Monetary Value</th>
                                                    <th >Song Title</th>
                                                    <th >Share Paying</th>
                                                    <th >Writer Name</th>
                                                    <th >Publisher Name</th>
                                                    <th >Operations</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            </tbody>
                                        </table>
                                        <div className="row-fluid">
                                            <div className="ws-3 ">
                                                <strong >Sum monetary value</strong> :
                                            </div>
                                            <div className="ws-3 ">
                                                <strong >Total units sold</strong> :
                                            </div>
                                        </div>
                                    </div>

                                    <div className="clearfix ng-hide" data-ng-show="factSales['RawPub']['totalItems'] &gt; 0">

                                        <div className="hover-box pull-left">
                                            <a className="icon-btn edit mt"><i className="icon-download1"></i>
                                                <span className="label label-danger pull-right  m0 p0 ml ng-hide" data-ng-show="false">might take a while</span>
                                            </a> <div className="hover-block">
                                                <a className="btn btn-large btn-app icon-btn edit btn-xs pull-left mr" href="javascript:void(0)" data-ng-click="exportPopupOptions(period)">Export for a
                                                    specific period</a>
                                                <a className="btn btn-large btn-app icon-btn edit btn-xs pull-left" href="javascript:void(0)" data-ng-click="exportPopupOptions('')">Export for all
                                                    periods</a>
                                            </div>
                                        </div>
                                        <div className="clearfix pull-right">
                                            {/* <ul className="pull-left pagination ng-isolate-scope ng-valid ng-hide" total-items="factSales['RawPub']['totalItems']" rotate="false" items-per-page="factSales['RawPub']['itemsPerPage']" boundary-links="true" ng-model="factSales['RawPub']['currentPage']" max-size="3" ng-change="factSales['RawPub']['pageChanged'](factSales['RawPub']['currentPage'])" data-ng-show="factSales['RawPub']['totalItems'] &gt; factSales['RawPub']['itemsPerPage']">
  <li ng-if="::boundaryLinks" ng-className="{disabled: noPrevious()||ngDisabled}" className=" disabled"><a href="" ng-click="selectPage(1, $event)" >First</a></li>
  <li ng-if="::directionLinks" ng-className="{disabled: noPrevious()||ngDisabled}" className=" disabled"><a href="" ng-click="selectPage(page - 1, $event)" >Previous</a></li>
  <li ng-repeat="page in pages track by $index" ng-className="{active: page.active,disabled: ngDisabled&amp;&amp;!page.active}" className=" active"><a href="" ng-click="selectPage(page.number, $event)" >1</a></li>
  <li ng-if="::directionLinks" ng-className="{disabled: noNext()||ngDisabled}" className=" disabled"><a href="" ng-click="selectPage(page + 1, $event)" >Next</a></li>
  <li ng-if="::boundaryLinks" ng-className="{disabled: noNext()||ngDisabled}" className=" disabled"><a href="" ng-click="selectPage(totalPages, $event)" >Last</a></li>
</ul> */}
                                            <div className="page-size-control">
                                                <select title="Items per page" data-ng-options="item as item for item in pageSizes" data-ng-change="loadFactSales()" data-ng-model="factSales['RawPub']['itemsPerPage']" data-ng-show="factSales['RawPub']['totalItems'] &gt; factSales['RawPub']['itemsPerPage']" className=" ng-hide"><option value="0" selected label="10">10</option><option value="1" label="20">20</option><option value="2" label="50">50</option><option value="3" label="100">100</option></select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div data-ng-show="isActiveType('ActPub')" className="hide">
                                    <div className="alert alert-info " data-ng-hide="factSales['ActPub']['totalItems'] &gt; 0">No data to
                                        display
                                    </div>
                                    <div className="table-responsive_big mt ng-hide" data-ng-show="factSales['ActPub']['totalItems'] &gt; 0">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th >Invoice Ref</th>
                                                    <th >Account Code</th>
                                                    <th >Matched Item</th>
                                                    <th >Territory Code</th>
                                                    <th >Formats/Source Codes</th>
                                                    <th >Units Sold</th>
                                                    <th >Monetary Value</th>
                                                    <th >Song Title</th>
                                                    <th >Share Paying</th>
                                                    <th >Writer Name</th>
                                                    <th >Publisher Name</th>
                                                    <th >Operations</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            </tbody>
                                        </table>
                                        <div className="row-fluid">
                                            <div className="ws-3 ">
                                                <strong>Sum monetary value</strong> :
                                            </div>
                                            <div className="ws-3 ">
                                                <strong>Total units sold</strong> :
                                            </div>
                                        </div>

                                    </div>

                                    <div className="clearfix ng-hide" data-ng-show="factSales['ActPub']['totalItems'] &gt; 0">

                                        <a className="hover-box pull-left">
                                        </a><a className="icon-btn edit"><i className="icon-download1"></i>
                                            <span className="label label-danger pull-right  m0 p0 ml ng-hide" data-ng-show="false">might take a while</span>
                                        </a><div className="hover-block" >
                                            <a className="btn btn-large btn-app icon-btn edit btn-xs pull-left mr" href="javascript:void(0)" data-ng-click="exportPopupOptions(period)">Export for a
                                                specific period</a>
                                            <a className="btn btn-large btn-app icon-btn edit btn-xs pull-left" href="javascript:void(0)" data-ng-click="exportPopupOptions('')">Export for all
                                                periods</a>
                                        </div>
                                    </div>
                                    <div className="clearfix pull-right">
                                        {/* <ul className="pull-left pagination ng-isolate-scope ng-valid ng-hide" total-items="factSales['ActPub']['totalItems']" rotate="false" ng-model="factSales['ActPub']['currentPage']" max-size="3" boundary-links="true" items-per-page="factSales['ActPub']['itemsPerPage']" ng-change="factSales['ActPub']['pageChanged'](factSales['ActPub']['currentPage'])" data-ng-show="factSales['ActPub']['totalItems'] &gt; factSales['ActPub']['itemsPerPage']">
  <li ng-if="::boundaryLinks" ng-className="{disabled: noPrevious()||ngDisabled}" className=" disabled"><a href="" ng-click="selectPage(1, $event)" >First</a></li>
  <li ng-if="::directionLinks" ng-className="{disabled: noPrevious()||ngDisabled}" className=" disabled"><a href="" ng-click="selectPage(page - 1, $event)" >Previous</a></li>
  <li ng-repeat="page in pages track by $index" ng-className="{active: page.active,disabled: ngDisabled&amp;&amp;!page.active}" className=" active"><a href="" ng-click="selectPage(page.number, $event)" >1</a></li>
  <li ng-if="::directionLinks" ng-className="{disabled: noNext()||ngDisabled}" className=" disabled"><a href="" ng-click="selectPage(page + 1, $event)" >Next</a></li>
  <li ng-if="::boundaryLinks" ng-className="{disabled: noNext()||ngDisabled}" className=" disabled"><a href="" ng-click="selectPage(totalPages, $event)" >Last</a></li>
</ul> */}
                                        <div className="page-size-control">
                                            <select data-ng-options="item as item for item in pageSizes" data-ng-model="factSales['ActPub']['itemsPerPage']" data-ng-change="loadFactSales()" data-ng-show="factSales['ActPub']['totalItems'] &gt; factSales['ActPub']['itemsPerPage']" className=" ng-hide"><option value="0" selected label="10">10</option><option value="1" label="20">20</option><option value="2" label="50">50</option><option value="3" label="100">100</option></select>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="table-responsive_big mt ws-12 hide">
                                <table className="table ng-hide" data-ng-show="selectedfactSalePub">
                                    <thead>
                                        <tr>
                                            <th >Unique ID</th>
                                            <th data-ng-show="type == 'RawPub'" className=" ng-hide">Song Code 1</th>
                                            <th data-ng-show="type == 'RawPub'" className=" ng-hide">Song Code 2</th>
                                            <th data-ng-show="type == 'RawPub'" className=" ng-hide">Song Code 3</th>
                                            <th data-ng-show="type == 'RawPub'" className=" ng-hide">Song Code 4</th>
                                            <th data-ng-show="type == 'RawPub'" className=" ng-hide">HFA Code</th>
                                            <th data-ng-show="type == 'RawPub'" className=" ng-hide">ISWC</th>
                                            <th >Dealer Price</th>
                                            <th >Retail Price</th>
                                            <th >Line Description</th>
                                            <th >Reported Item</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td ></td>
                                            <td data-ng-show="type == 'RawPub'" className=" ng-hide"></td>
                                            <td data-ng-show="type == 'RawPub'" className=" ng-hide"></td>
                                            <td data-ng-show="type == 'RawPub'" className=" ng-hide"></td>
                                            <td data-ng-show="type == 'RawPub'" className=" ng-hide"></td>
                                            <td data-ng-show="type == 'RawPub'" className=" ng-hide"></td>
                                            <td data-ng-show="type == 'RawPub'" className=" ng-hide"></td>
                                            <td className="text-right "></td>
                                            <td className="text-right "></td>
                                            <td ></td>
                                            <td ></td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>

                        </div>
                    </div>

                </div>

            </div>
            {
                (() => {
                    if (matchingTerritoriesStatus) {
                        return <MatchingForm param={matchingTerritoriesStatus} MatchingTerritoriesClose={MatchingTerritoriesClose}/>
                    }
                })()
            }
            {
                (() => {
                    if (isrcMappingStatus) {
                        return <ISRCMappingBox param={isrcMappingStatus} ISRCMappingClose={ISRCMappingClose}/>
                    }
                })()
            }
        </div>
    );
}


